<template>
  <div>
    <div class="row page-title-header">
      <div class="col-12">
        <div class="page-header">
          <b-breadcrumb class="m-0">
            <b-breadcrumb-item :to="{ name: 'DashboardHome' }">
              <i class="fa fa-home"></i>
            </b-breadcrumb-item>
            <b-breadcrumb-item active>組織資料中心</b-breadcrumb-item>
            <b-breadcrumb-item active>方案管理</b-breadcrumb-item>
          </b-breadcrumb>
        </div>
      </div>
    </div>
    <b-card>
      <div class="row d-flex mb-4 mb-xl-2 justify-content-between">
        <h4 class="col-12 col-xl-2 mb-2 mb-xl-0 font-weight-bold">
          {{ `【${organization.name}】方案管理` }}
        </h4>
      </div>
      <div class="d-flex mb-4 mb-xl-2 justify-content-end">
        <button
          v-if="checkPermission([consts.SUITE_SETTING])"
          class="btn btn-primary"
          @click="set"
        >
          設定
        </button>
      </div>

      <b-table
        striped
        hover
        responsive
        :items="suites"
        :fields="fields"
        :busy="isLoading"
      >
        <template #table-busy>
          <div class="text-center my-2">
            <b-spinner class="align-middle"></b-spinner>
          </div>
        </template>

        <template #cell(checkbox)="data">
          <b-form-checkbox
            @change="clickCheckbox($event, data)"
          ></b-form-checkbox>
        </template>
      </b-table>

      <CustomPagination
        :currentPage="query.page"
        :totalRows="total"
        :perPage="query.per_page"
        @page-change="handlePageChange"
        @per-page-change="handlePerPageChange"
      />
    </b-card>
  </div>
</template>

<script>
import suiteApi from "@/apis/suite";
import * as consts from "@/consts";
import { mapState, mapGetters } from "vuex";
import CustomPagination from "@/components/Page/Dashboard/CustomPagination.vue";
import { paginationMixin } from "@/mixins/pagination";
import { updateQueryFromRoute, updateUrlWithoutReload } from "@/utils/updateUrl";
import PermissionChecker from "@/utils/PermissionChecker";

export default {
  components: { CustomPagination },
  mixins: [paginationMixin],
  data() {
    return {
      consts,
      isLoading: false,
      suites: [],
      selectedSuiteIds: [],
      initialized: false,
      query: {
        page: 1,
        per_page: 10,
      },
      fields: [
        {
          key: "checkbox",
          label: "",
        },
        {
          key: "code",
          label: "代碼",
        },
        {
          key: "name",
          label: "名稱",
        },
      ],
      total: 0,
    };
  },
  computed: {
    ...mapState("general", {
      organization: (state) => state.organization,
    }),
    ...mapGetters("route", ["routeQuery"]),
    queryWatcher() {
      return `${this.query.page}-${this.query.per_page}`;
    },
  },
  watch: {
    queryWatcher: {
      handler() {
        if (!this.initialized) return;
        updateUrlWithoutReload(this.query, this.$store, this.$router);
      },
    },
    routeQuery() {
      if (!this.initialized) return;
      this.fetchSuites();
    },
  },
  created() {
    this.query = updateQueryFromRoute(this.$route, this.$store, this.query);
  },
  mounted() {
    this.init();
  },
  methods: {
    async init() {
      await this.fetchSuites();
      this.initialized = true;
    },
    async fetchSuites() {
      try {
        this.isLoading = true;

        const params = {...this.query};
        const { data } = await suiteApi.list(params);
        this.total = data.meta.total;
        this.query.per_page = data.meta.per_page;
        this.suites = data.data;
      } catch (error) {
        console.log("");
      }
      this.isLoading = false;
    },
    onRowSelected(rows) {
      console.log(rows);
    },
    clickCheckbox(event, data) {
      if (event) {
        this.selectedSuiteIds.push(data.item.id);
      } else {
        this.selectedSuiteIds = this.selectedSuiteIds.filter(
          (id) => id !== data.item.id
        );
      }
    },
    async set() {
      try {
        this.isLoading = true;

        await suiteApi.set({
          suite_ids: this.selectedSuiteIds,
        });

        this.$swal.fire({
          icon: "success",
          title: "設定成功",
        });

        this.selectedSuiteIds = [];
      } catch (error) {
        console.log(error);
      }

      this.isLoading = false;
    },
    checkPermission(permissions) {
      const checker = new PermissionChecker();      
      return checker.check(permissions);
    },
  },
};
</script>
